import * as React from "react";
import { SVGProps } from "react";
const SvgLogoFindRecords = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-find-records_svg__a)">
      <path
        d="M7.342.5a6.85 6.85 0 0 1 6.842 6.842 6.801 6.801 0 0 1-1.444 4.189l3.76 3.76-1.21 1.209-3.76-3.76a6.8 6.8 0 0 1-4.188 1.444A6.85 6.85 0 0 1 .5 7.342 6.85 6.85 0 0 1 7.342.5Zm0 1.71a5.137 5.137 0 0 0-5.131 5.132 5.137 5.137 0 0 0 5.131 5.131 5.137 5.137 0 0 0 5.131-5.131 5.137 5.137 0 0 0-5.131-5.131ZM4.5 5.36c1.33-1.145 3.637-1.145 4.968 0 .328.28.588.614.765.981.177.368.268.762.267 1.16H8.742c0-.403-.184-.783-.517-1.07-.664-.572-1.816-.573-2.484 0L4.5 5.36Z"
        fill="#FFB938"
      />
    </g>
    <defs>
      <clipPath id="logo-find-records_svg__a">
        <path fill="#fff" transform="translate(.5 .5)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoFindRecords;
